import { render, staticRenderFns } from "./navCollapseList.vue?vue&type=template&id=663e5a84&scoped=true&"
import script from "./navCollapseList.vue?vue&type=script&lang=js&"
export * from "./navCollapseList.vue?vue&type=script&lang=js&"
import style0 from "./navCollapseList.vue?vue&type=style&index=0&id=663e5a84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663e5a84",
  null
  
)

export default component.exports